import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { startLoading } from 'store/loading/actions';

import translations from '../../services/translations/translations';

const SidebarLogout = (): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const user = useSelector((state: any) => state.users.current);
  const dispatch = useDispatch();

  const logout = () => {
    dispatch(startLoading('logout-operation'));
    localStorage.removeItem('accessToken');
    window.location.href = user.eworkbook;
  };

  if (user === null) {
    return null;
  }

  return (
    <div
      className="sidebar-link"
      style={{ marginTop: 'auto' }}
      onClick={() => {
        logout();
      }}
      aria-hidden
    >
      <p className="sidebar-link-text">{t('Logout')}</p>
    </div>
  );
};

export default SidebarLogout;
